<div class="search-options flex flex-row flex-wrap gap-[25px] justify-start items-baseline">
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.USERNAME' | translate
    }}</mat-label>
    <input
      data-at-login-id
      matInput
      name="loginId"
      [(ngModel)]="loginId"
      (keyup.enter)="search()"
      [readonly]="!isSearchByUserCriteriaDisabled()"
      gtm="onEditTextField"
      gtmAction="Login id"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <button
      data-at-close-btn
      *ngIf="loginId"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="User search query"
      gtmCategory="search"
      gtmLabel="clearUserId"
      (click)="loginId = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.FIRST_NAME' | translate
    }}</mat-label>
    <input
      data-at-firstName-field
      matInput
      name="firstName"
      [(ngModel)]="firstName"
      (keyup.enter)="search()"
      [readonly]="!isSearchByUserCriteriaDisabled()"
      gtm="onEditTextField"
      gtmAction="First name"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <button
      data-at-close-btn
      *ngIf="firstName"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="User search query"
      gtmCategory="search"
      gtmLabel="clearFirstName"
      (click)="firstName = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.FAMILY_NAME' | translate
    }}</mat-label>
    <input
      data-at-family-name
      matInput
      name="familyName"
      [(ngModel)]="familyName"
      (keyup.enter)="search()"
      [readonly]="!isSearchByUserCriteriaDisabled()"
      gtm="onEditTextField"
      gtmAction="Family name"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <button
      data-at-close-btn
      *ngIf="familyName"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="User search query"
      gtmCategory="search"
      gtmLabel="clearFamilyName"
      (click)="familyName = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{ '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.CITY' | translate }}</mat-label>
    <input
      data-at-city
      matInput
      name="city"
      [(ngModel)]="city"
      (keyup.enter)="search()"
      [readonly]="!isSearchByUserCriteriaDisabled()"
      gtm="onEditTextField"
      gtmAction="City text"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <button
      data-at-close-btn
      *ngIf="city"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="User search query"
      gtmCategory="search"
      gtmLabel="clearCity"
      (click)="city = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.STREET' | translate
    }}</mat-label>
    <input
      data-at-street
      matInput
      name="street"
      [(ngModel)]="street"
      (keyup.enter)="search()"
      [readonly]="!isSearchByUserCriteriaDisabled()"
      gtm="onEditTextField"
      gtmAction="Street text"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <button
      data-at-close-btn
      *ngIf="street"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="User search query"
      gtmCategory="search"
      gtmLabel="clearStreet"
      (click)="street = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.POSTAL_CODE' | translate
    }}</mat-label>
    <input
      data-at-postal-code
      matInput
      name="postalCode"
      [(ngModel)]="postalCode"
      (keyup.enter)="search()"
      [readonly]="!isSearchByUserCriteriaDisabled()"
      gtm="onEditTextField"
      gtmAction="Postal code"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <button
      data-at-close-btn
      *ngIf="postalCode"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="User search query"
      gtmCategory="search"
      gtmLabel="clearPostalCode"
      (click)="postalCode = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.COMPANY_NUMBER' | translate
    }}</mat-label>
    <input
      data-at-company-number
      matInput
      name="companyNumber"
      [(ngModel)]="companyNumber"
      (keyup.enter)="search()"
      [readonly]="!isSearchByCompanyIdDisabled()"
      gtm="onEditTextField"
      gtmAction="Company number"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <button
      data-at-close-btn
      *ngIf="companyNumber"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="User search query"
      gtmCategory="search"
      gtmLabel="clearCompanyNumber"
      (click)="companyNumber = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<div
  data-at-installations-migration-btn-start-migration
  *ngIf="installationsMigrationService.isUserPermittedToMigrateInstallation()"
  class="migration__wrapper flex flex-col flex-wrap gap-[16px] justify-start items-stretch"
  gtm="onOpen"
  gtmAction="Migrate installations modal"
  gtmCategory="search"
  (click)="installationsMigrationService.openMigrationModal()"
>
  <p class="migration__title">{{ '+MIGRATION.BUTTON_LABEL' | translate }} »</p>
  <p class="migration__description">{{ '+MIGRATION.BUTTON_DESCRIPTION' | translate }}</p>
</div>

<div class="button-wrapper flex flex-row justify-end items-center">
  <button
    mat-stroked-button
    color="primary"
    gtm="onClearSearch"
    gtmAction="User search query"
    gtmCategory="search"
    (click)="clear()"
  >
    {{ 'GENERAL.BUTTON.CLEAR' | translate }}
  </button>
  <button
    data-at-search-users-button
    [attr.data-at-disabled]="isSearchByCompanyIdDisabled() && isSearchByUserCriteriaDisabled()"
    disabled
    mat-raised-button
    color="primary"
    gtm="onSearch"
    gtmAction="User"
    gtmCategory="search"
    (click)="search()"
    [disabled]="isSearchByCompanyIdDisabled() && isSearchByUserCriteriaDisabled()"
  >
    {{ 'GENERAL.BUTTON.SEARCH' | translate }}
  </button>
</div>
